import React, { useState } from "react";
import TitleSection from "../../../../../../Shared/TitleSection/TitleSection";
import styles from "../AssociateActivity.module.css";
import { FiTarget } from "react-icons/fi";
import { GrGroup, GrPlan } from "react-icons/gr";
import PersonalGoal from "./PersonalGoal/PersonalGoal";
import ProfessionalGoal from "./ProfessionalGoal/ProfessionalGoal";
import TeamTarget from "./TeamTarget/TeamTarget";
import ProjectPlanning from "./ProjectPlanning/ProjectPlanning";
const MyGoal = () => {
  const [activeTab, setActiveTab] = useState("Personal Goal");

  const tabs = [
    { label: "Personal Goal", color: "#3b82f6", icon: <FiTarget /> },
    { label: "Professional Goal", color: "#fce8e6", icon: <FiTarget /> },
    { label: "Team Target", color: "#fce8e6", icon: <GrGroup /> },
    { label: "Project Planning", color: "#fff7e6", icon: <GrPlan /> },
  ];
  return (
    <>
      <div className="content">
        <TitleSection text="Goal" />
        <div className="my-2">
          <div className={styles.tabsContainer}>
            {tabs.map((tab, i) => (
              <button
                key={tab.label}
                className={`${styles.tab} ${activeTab === tab.label || activeTab === tab.lable2 ? styles.activeTab : ""}`}
                style={
                  activeTab === tab.label || activeTab === tab.lable2
                    ? { borderBottomColor: tab.color }
                    : {}
                }
                onClick={() =>
                  i > 3 ? setActiveTab(tab.lable2) : setActiveTab(tab.label)
                }
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        {activeTab === "Personal Goal" && <PersonalGoal />}
        {activeTab === "Professional Goal" && <ProfessionalGoal />}
        {activeTab === "Team Target" && <TeamTarget />}
        {activeTab === "Project Planning" && <ProjectPlanning />}
      </div>
    </>
  );
};

export default MyGoal;
